// The door's second column: the non-owner destinations an invited session opens,
// read straight from the rail registry so the door can never claim a
// destination the product does not have. It fills the ground beside the
// sign-in column with something true about this workspace rather than leaving
// 78 per cent of the first screen empty, and it is drawn in the context
// list's own row rhythm, so the door already looks like the desk.
//
// Nothing here is a control: signed out, none of these is reachable.
import { Panel } from '../../ui/Panel';
import { destinationsForRole, railGroupsForRole } from '../../shell/destinations';

export function WorkspaceMap() {
  const destinations = destinationsForRole(null);
  const groups = railGroupsForRole(null);
  return (
    <Panel
      title="Inside the workspace"
      meta={`${destinations.length} destinations`}
      foot="Evidence is scoped to the workspace named on your invitation. No destination is a demo, and nothing in here is public."
    >
      <div className="door-map">
        {groups.map((group) => {
          // Alerts and Settings are one destination that carries the group's
          // own name; printing the header as well would say it twice.
          const named =
            group.destinations.length === 1 && group.destinations[0]?.label === group.label;
          return (
            <div className="door-map-grp" key={group.id}>
              {named ? null : <p className="door-map-h">{group.label}</p>}
              {group.destinations.map((destination) => (
                <p className="door-map-row" key={destination.id}>
                  {destination.label}
                </p>
              ))}
            </div>
          );
        })}
      </div>
    </Panel>
  );
}
